module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/cut-above-ad17ec79e3e1a098ec315fca8aa77c3b.jpg";